import React from 'react';
import cashIcon from '../../../../assets/mobile-app/images/img_wallet.png';
import walletIcon from '../../../../assets/mobile-app/images/img_green_wallet.png';
import bidvIcon from '../../../../assets/mobile-app/icons/ic_logobidv.png';
import './RideAppIcon.scss';

const SVGIcons = {
  // Navigation / Search
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),

  // Calendar
  calendar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="3" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),

  // Time / Clock (matching ic_time.svg)
  time: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 14" />
    </svg>
  ),

  // Swap locations (matching mobile ic_swap.svg)
  swap: (
    <svg viewBox="0 0 14 14" fill="currentColor">
      <path d="M7.66309 13.3437C7.66309 13.6992 7.3623 14 7.00684 14C4.70996 14 2.85059 12.1133 2.85059 9.84375L2.85059 3.96484L1.10059 5.6875C0.854492 5.96094 0.444336 5.96094 0.198242 5.6875C0.0615232 5.57812 0.0068357 5.41406 0.00683571 5.25C0.00683572 5.05859 0.0615232 4.89453 0.198242 4.75781L3.04199 1.91406C3.28809 1.66797 3.69824 1.66797 3.94434 1.91406L6.78809 4.75781C7.06152 5.03125 7.06152 5.44141 6.78809 5.6875C6.54199 5.96094 6.13184 5.96094 5.88574 5.6875L4.16309 3.96484L4.16309 9.84375C4.16309 11.4023 5.4209 12.6875 7.00684 12.6875C7.3623 12.6875 7.66309 12.9609 7.66309 13.3437ZM9.85059 4.15625C9.85059 2.57031 8.56543 1.3125 7.00684 1.3125C6.62402 1.3125 6.35059 1.01172 6.35059 0.65625C6.35059 0.273437 6.62402 0 7.00684 0C9.27637 0 11.1631 1.85937 11.1631 4.15625L11.1631 10.0078L12.8857 8.28516C13.1318 8.01172 13.542 8.01172 13.7881 8.28516C14.0615 8.53125 14.0615 8.94141 13.7881 9.1875L10.9443 12.0312C10.6982 12.3047 10.2881 12.3047 10.042 12.0312L7.19824 9.1875C7.06152 9.07812 7.00684 8.91406 7.00684 8.75C7.00684 8.55859 7.06152 8.39453 7.19824 8.28516C7.44434 8.01172 7.85449 8.01172 8.10059 8.28516L9.85059 10.0078L9.85059 4.15625Z" />
    </svg>
  ),

  // Pickup marker (Flutter app concentric green dot)
  pickup: (
    <svg viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7" stroke="#20ba64" strokeWidth="2.5" />
      <circle cx="10" cy="10" r="3" fill="#20ba64" />
    </svg>
  ),

  // Destination marker (Flutter app location pin in danger red)
  destination: (
    <svg viewBox="0 0 24 24" fill="#f04438">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    </svg>
  ),

  // People / seats (Icons.people_outline_rounded)
  people: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),

  // Single person (Icons.person_outline_rounded)
  person: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),

  // Arrow down / dropdown (matching ic_chevron_bottom.svg)
  arrowDown: (
    <svg viewBox="0 0 14 9" fill="currentColor">
      <path d="M7 8.50781L6.37109 7.87891L1.12109 2.62891L0.492188 2L1.75 0.769531L2.35156 1.39844L7 6.01953L11.6211 1.39844L12.25 0.769531L13.4805 2L12.8516 2.62891L7.60156 7.87891L7 8.50781Z" />
    </svg>
  ),

  // Chevron right (matching ic_chevron_right.svg)
  chevronRight: (
    <svg viewBox="0 0 8 14" fill="currentColor">
      <path d="M2.06265 0.515779L7.7814 6.48453C7.9064 6.64078 8.00015 6.82828 8.00015 7.01578C8.00015 7.20328 7.9064 7.39078 7.7814 7.51578L2.06265 13.4845C1.7814 13.797 1.2814 13.797 1.00015 13.5158C0.687654 13.2345 0.687654 12.7658 0.968904 12.4533L6.2189 6.98453L0.968904 1.54703C0.687654 1.26578 0.687654 0.765779 1.00015 0.484529C1.2814 0.203279 1.7814 0.203279 2.06265 0.515779Z" />
    </svg>
  ),

  // Close X (matching ic_close.svg)
  close: (
    <svg viewBox="0 0 10 10" fill="currentColor">
      <path d="M9.25781 1.25977L5.74219 4.77539L9.22852 8.26172C9.52148 8.52539 9.52148 8.96484 9.22852 9.22852C8.96484 9.52148 8.52539 9.52148 8.26172 9.22852L4.74609 5.74219L1.25977 9.22852C0.996094 9.52148 0.556641 9.52148 0.292969 9.22852C0 8.96484 0 8.52539 0.292969 8.23242L3.7793 4.74609L0.292969 1.25977C0 0.996094 0 0.556641 0.292969 0.263672C0.556641 0 0.996094 0 1.28906 0.263672L4.77539 3.7793L8.26172 0.292969C8.52539 0 8.96484 0 9.25781 0.292969C9.52148 0.556641 9.52148 0.996094 9.25781 1.25977Z" />
    </svg>
  ),

  // Checkmark (Icons.check_rounded)
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),

  // Home
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10l9-7 9 7v11a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1V10z" />
    </svg>
  ),

  // Work / Briefcase
  work: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
    </svg>
  ),

  // Star outline
  star: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),

  // Star filled
  starFilled: (
    <svg viewBox="0 0 24 24" fill="#F9B700">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),

  // History (matching mobile ic_history.svg)
  history: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 5.5C10.7144 5.5 9.45772 5.88122 8.3888 6.59545C7.31988 7.30968 6.48676 8.32484 5.99479 9.51256C5.50282 10.7003 5.37409 12.0072 5.6249 13.2681C5.8757 14.529 6.49477 15.6872 7.40381 16.5962C8.31285 17.5052 9.47104 18.1243 10.7319 18.3751C11.9928 18.6259 13.2997 18.4972 14.4874 18.0052C15.6752 17.5132 16.6903 16.6801 17.4046 15.6112C18.1188 14.5423 18.5 13.2856 18.5 12C18.4982 10.2767 17.8128 8.62441 16.5942 7.40582C15.3756 6.18722 13.7234 5.50182 12 5.5ZM12 17.5C10.9122 17.5 9.84884 17.1774 8.94437 16.5731C8.0399 15.9687 7.33495 15.1098 6.91867 14.1048C6.50238 13.0998 6.39347 11.9939 6.60568 10.927C6.8179 9.86011 7.34173 8.8801 8.11092 8.11091C8.8801 7.34172 9.86011 6.8179 10.927 6.60568C11.9939 6.39346 13.0998 6.50238 14.1048 6.91866C15.1098 7.33494 15.9687 8.03989 16.5731 8.94436C17.1774 9.84883 17.5 10.9122 17.5 12C17.4983 13.4582 16.9184 14.8562 15.8873 15.8873C14.8562 16.9184 13.4582 17.4983 12 17.5ZM16 12C16 12.1326 15.9473 12.2598 15.8536 12.3536C15.7598 12.4473 15.6326 12.5 15.5 12.5H12C11.8674 12.5 11.7402 12.4473 11.6464 12.3536C11.5527 12.2598 11.5 12.1326 11.5 12V8.5C11.5 8.36739 11.5527 8.24021 11.6464 8.14645C11.7402 8.05268 11.8674 8 12 8C12.1326 8 12.2598 8.05268 12.3536 8.14645C12.4473 8.24021 12.5 8.36739 12.5 8.5V11.5H15.5C15.6326 11.5 15.7598 11.5527 15.8536 11.6464C15.9473 11.7402 16 11.8674 16 12Z" />
    </svg>
  ),

  // Car (Icons.directions_car_outlined)
  car: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 11l2-6h10l2 6" />
      <path d="M3 11h18l1 4v5h-3v-2H5v2H2v-5l1-4z" />
      <circle cx="7" cy="15" r="1.5" />
      <circle cx="17" cy="15" r="1.5" />
    </svg>
  ),

  // Message / Chat bubble (Icons.message_outlined)
  message: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),

  // Map outline
  map: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
      <line x1="8" y1="2" x2="8" y2="18" />
      <line x1="16" y1="6" x2="16" y2="22" />
    </svg>
  ),

  // Locate me (Icons.my_location_rounded)
  locate: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="7" />
      <line x1="12" y1="1" x2="12" y2="5" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="1" y1="12" x2="5" y2="12" />
      <line x1="19" y1="12" x2="23" y2="12" />
      <circle cx="12" cy="12" r="2.5" fill="currentColor" />
    </svg>
  ),

  // Info
  info: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" strokeWidth="2.5" />
    </svg>
  ),

  // Warning
  warning: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#F79009" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth="2.5" />
    </svg>
  ),

  // Add / Plus
  add: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),

  // Minus / Remove
  minus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),

  // Edit / Pencil
  edit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),

  // Trash / Delete
  trash: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),

  // Bookmark / Tag
  bookmark: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  ),

  // Tune / Sliders
  tune: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" />
      <line x1="9" y1="8" x2="15" y2="8" />
      <line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  ),

  // Filter
  filter: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),

  // Refresh / Sync
  refresh: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  sync: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),

  // Send paper plane
  send: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),

  // Promo code tag
  promo: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" strokeWidth="2.5" />
    </svg>
  ),

  // Wallet
  wallet: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <line x1="2" y1="10" x2="22" y2="10" />
      <circle cx="17" cy="14" r="1.5" fill="currentColor" />
    </svg>
  ),

  // Payments
  payments: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),

  // Road
  road: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19L8 5M20 19L16 5M12 7V9M12 13V15M12 19V21" />
    </svg>
  ),

  // Event busy
  eventBusy: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="9" y1="14" x2="15" y2="18" />
      <line x1="15" y1="14" x2="9" y2="18" />
    </svg>
  ),
};

const imageIcons = {
  cash: cashIcon,
  rideWallet: walletIcon,
  bidv: bidvIcon,
  ic_logobidv: bidvIcon,
};

const RideAppIcon = ({ name, className = '', alt = '' }) => {
  if (imageIcons[name]) {
    return (
      <img
        className={`ride-app-icon ride-app-icon--image ride-app-icon--${name} ${className}`.trim()}
        src={imageIcons[name]}
        alt={alt || name}
      />
    );
  }
  const svg = SVGIcons[name];
  if (!svg) return null;
  return React.cloneElement(svg, {
    className: `ride-app-icon ride-app-icon--${name} ${className}`.trim(),
    'aria-hidden': 'true',
    focusable: 'false',
  });
};

export default RideAppIcon;
